'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SiteMap = undefined;

var _themeProvider = require('@spp/theme-provider');

var _SiteMap = require('./SiteMap');

var _SiteMap2 = _interopRequireDefault(_SiteMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default */
exports.SiteMap = _SiteMap2.default;
exports.default = (0, _themeProvider.themer)('@spp/cn-sitemap')(_SiteMap2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/SiteMap/index.js
 ** module id = 617
 ** module chunks = 1
 **/